import MicroModal from 'micromodal';

export const initializeModal = (): void => {
  MicroModal.init({
    openTrigger: 'data-micromodal-trigger', // [3]
    closeTrigger: 'data-micromodal-close', // [4]
    disableScroll: true, // [5]
    disableFocus: false, // [6]
    // awaitOpenAnimation: true, // [7]
    // awaitCloseAnimation: true, // [8]
    debugMode: false, // [9]
  });
};
